const getCart = async () => {
  const result = await fetch('/cart.js')
  const json = await result.json()
  return json
}

const removeFromCart = async (index) => {
  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items')
  cartItems.updateQuantity(index, 0);
}

const addMultipleToCart = async (items, data = {}) => {
  try {
    const requestData = {
      ...data,
      items,
      attributes: {
        ...((data && data.attributes) || {})
      }
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;

  } catch (error) {
    console.error('Error:', error);
    throw error;  // If you want the error to propagate up
  }
}